export default "/images/ceb3147fa7ae1abff31847d2906275cb.avif";